import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 218  -  强制存读档
 */

export default class EventForcedSaveRead extends EventBase {
  /**
   * 强制存读档的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '1', '0']
  }

  // #region 事件中主要属性参数
  /**
   * 存档还是读档(0:存档 1：读档)
   */
  get IsRead() {
    return this.Parameter?.[0] === '1'
  }
  set IsRead(value) {
    this.Parameter && (this.Parameter[0] = value ? '1' : '0')
  }

  /**
   * 存档：存档号 读档：读取的存档号（1~设置最大存档数）
   */
  get Number() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set Number(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 是否读档后删除存档（0：不删除 1：删除）
   */
  get IsDelete() {
    return this.Parameter?.[2] === '1'
  }
  set IsDelete(value) {
    this.Parameter && (this.Parameter[2] = value ? '1' : '0')
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.ForcedSaveRead

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
